<template>
  <div class="head">
    <div class="center">
      <p class="name">电 瓷 数 字 化 车 间 智 能 生 产 大 脑</p>
      <img class="logo" src="@/assets/logo/logo_new.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.head {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo {
    position: absolute;
    top: -4px;
    left: -50px;
    width: 40px;
    height: 40px;
  }
  .center {
    position: relative;
    width: 550px;
    height: 70px;
    font-family: Alimama ShuHeiTi;
    font-weight: bold;
    font-size: 32px;
    color: #ffffff;
    background: linear-gradient(0deg, #b1cdff 0%, #fefeff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .name {
    font-size: 32px;
    color: #ffffff;
    margin: 0;
  }
}
</style>
